import "./Footer.css";
import logo from "../../assets/images/logo.png";
import facebook from "../../assets/svg/facebook.svg";
import instagram from "../../assets/svg/instagram.svg";
import linkedin from "../../assets/svg/linkedin.svg";
import { useDialog } from "../DialogProvider/DialogProvider";

function Footer() {
  const { openDialog } = useDialog();
  return (
    <div className="Footer">
      <div className="top-content">
        <img src={logo} alt="" className="logo" />
        <div className="link-content">
          <ul>
            <li onClick={() => openDialog("contactus")}>Contact Us</li>
            <li>Get the App</li>
            <li
              onClick={() => {
                window.open("https://portal.brainyclock.com", "_blank");
              }}
            >
              Go to Dashboard
            </li>
          </ul>
        </div>
      </div>
      <div className="Footer-Divider"></div>
      <div className="d-flex align-items-center w-100 justify-content-between">
        <div className="theme-text-small-16">info@brainyclock.com</div>
        <div className="d-flex align-items-center gap-34">
          <img src={facebook} alt="facebook" />
          <img src={instagram} alt="instagram" />
          <img src={linkedin} alt="linkedin" />
        </div>
      </div>
    </div>
  );
}

export default Footer;
